import { AppDispatch } from "state/store";
import { openExternalUrl } from "./openExternalUrl";
import type { DrillSmartModalData } from "./drillSmart";

export type { DrillSmartModalData } from "./drillSmart";

export function getDrillSmartOnStartDrill(
  modalData: DrillSmartModalData | null | undefined,
  openRefreshModal: (contentType?: string) => void,
  openExternalUrlFn: typeof openExternalUrl,
  dispatch: AppDispatch,
  testType: string | undefined
): ((drillOrPayload?: any) => void) | undefined {
  if (!modalData) {
    return undefined;
  }

  return (drillOrPayload?: any) => {
    const refreshModalOpen = (contentType?: string) => {
      openRefreshModal(contentType || "Test");
    };

    // Individual drill: use ContentObjectType from DrillSmartContent.Content item
    const contentObjectTypeFromData =
      drillOrPayload?.ContentObjectType ?? drillOrPayload?.contentObjectType ?? "Drill";
    const isIndividualDrill =
      drillOrPayload?.LaunchUrl && contentObjectTypeFromData !== "DrillSmart";

    if (isIndividualDrill) {
      openExternalUrlFn({
        url: drillOrPayload.LaunchUrl,
        contentObjectType: contentObjectTypeFromData,
        testType,
        dispatch,
        onRefreshModalOpen: refreshModalOpen,
      });
    } else if (modalData?.drillSmartLaunchUrl) {
      openExternalUrlFn({
        url: modalData.drillSmartLaunchUrl,
        contentObjectType: "DrillSmart",
        testType,
        dispatch,
        onRefreshModalOpen: refreshModalOpen,
      });
    }
  };
}
